<div class="w-full flex flex-col flex-1 min-h-0">
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden gap-4">

    <div class="shrink-0 flex flex-wrap items-center gap-2 px-1">
      <p-button
        label="Endpoints"
        icon="pi pi-send"
        [severity]="activeTab() === 'endpoints' ? 'primary' : 'secondary'"
        [outlined]="activeTab() !== 'endpoints'"
        [rounded]="true"
        (onClick)="setTab('endpoints')" />
      <p-button
        label="Historial de eventos"
        icon="pi pi-history"
        [severity]="activeTab() === 'events' ? 'primary' : 'secondary'"
        [outlined]="activeTab() !== 'events'"
        [rounded]="true"
        (onClick)="setTab('events')" />
    </div>

    @if (activeTab() === 'endpoints') {
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-send"></i>
                </span>
                Webhooks
              </h2>
              <p class="text-sm text-slate-500 mt-1">Endpoints que reciben notificaciones. Cada uno puede suscribirse a eventos distintos.</p>
            </div>
            <div class="w-full sm:w-auto flex justify-end">
              <a routerLink="/webhooks/new" appDisableUnless="WEBHOOK_WRITE">
                <p-button label="Nuevo webhook" icon="pi pi-plus" severity="primary" appDisableUnless="WEBHOOK_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="webhooks()"
            [scrollable]="true"
            scrollHeight="flex"
            [loading]="webhooksLoading()"
            [tableStyle]="{ width: '100%' }"
            styleClass="webhooks-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2">Endpoint</th>
                <th class="!px-2 hidden sm:table-cell">Descripción</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Estado</th>
                <th class="!px-2 !whitespace-nowrap hidden md:table-cell">Eventos</th>
                <th class="!px-2 !whitespace-nowrap hidden lg:table-cell !text-center">Creado</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-webhook>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openWebhookDetails(webhook)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2 min-w-0">
                    <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-sky-600">
                      <i class="pi pi-link text-sm"></i>
                    </span>
                    <span class="text-sm font-medium text-slate-900 truncate" [pTooltip]="webhook.endpoint" tooltipPosition="top">{{ webhook.endpoint }}</span>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 hidden sm:table-cell">{{ webhook.description || '—' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 !text-center !whitespace-nowrap">
                  <p-tag class="!text-xs" [value]="webhook.enabled ? 'Activo' : 'Inactivo'" [severity]="webhook.enabled ? 'success' : 'secondary'" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 hidden md:table-cell !whitespace-nowrap">{{ eventCountLabel(webhook) }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 hidden lg:table-cell !text-center !whitespace-nowrap">{{ webhook.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()">
                  <p-button
                    icon="pi pi-ellipsis-v"
                    rounded
                    [text]="true"
                    severity="secondary"
                    (onClick)="openRowMenu($event, webhook)"
                    pTooltip="Acciones"
                    tooltipPosition="left"
                    appendTo="body" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No hay webhooks configurados. Crea uno para empezar a recibir eventos.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }

    @if (activeTab() === 'events') {
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-history"></i>
                </span>
                Historial de eventos
              </h2>
              <p class="text-sm text-slate-500 mt-1">Entregas generadas hacia tus endpoints suscritos.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                [rounded]="true"
                [loading]="loading()"
                (onClick)="refreshTable()"
                pTooltip="Actualizar tabla"
                tooltipPosition="left"
                appendTo="body" />
              <p-button
                [label]="autoRefreshEnabled() ? 'Detener auto-actualización' : 'Auto-actualizar'"
                [icon]="autoRefreshEnabled() ? 'pi pi-spin pi-spinner' : 'pi pi-play'"
                [severity]="autoRefreshEnabled() ? 'danger' : 'secondary'"
                [rounded]="true"
                (onClick)="toggleAutoRefresh()"
                appendTo="body" />
            </div>
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="events()"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalRecords()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} eventos"
            [loading]="loading()"
            [paginator]="true"
            (onLazyLoad)="loadEvents($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="webhooks-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end">
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2 !whitespace-nowrap">ID</th>
                <th class="!px-2">Tipo de Evento</th>
                <th class="!px-2">Webhook</th>
                <th class="!px-2 !whitespace-nowrap">Estado</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Intentos</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Creado</th>
                <th class="!px-2 !whitespace-nowrap !text-center hidden sm:table-cell">Último Intento</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="showDetails(event)">
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap">
                  <div class="flex items-center gap-2">
                    <i class="pi pi-bolt text-sky-500"></i>
                    {{ event.id }}
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm font-medium text-slate-900">{{ event.eventType }}</td>
                <td class="!px-2 !py-2 !border-slate-100" (click)="$event.stopPropagation()">
                  @if (event.webhookId != null) {
                    <a
                      href="#"
                      (click)="openWebhookDetails(null, event.webhookId); $event.preventDefault()"
                      class="group flex flex-col min-w-0 max-w-[260px] no-underline hover:bg-sky-50 rounded-md px-1.5 py-1 -mx-1.5 transition-colors"
                      [pTooltip]="event.webhookEndpoint || ''"
                      tooltipPosition="top"
                      appendTo="body">
                      <span class="text-sm font-medium text-sky-700 group-hover:text-sky-800 truncate">
                        #{{ event.webhookId }}
                        @if (event.webhookDescription) {
                          <span class="text-slate-700"> · {{ event.webhookDescription }}</span>
                        }
                      </span>
                      <span class="text-xs text-slate-500 truncate font-mono">{{ event.webhookEndpoint }}</span>
                    </a>
                  } @else {
                    <span class="text-sm text-slate-400">Sin webhook</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag class="!text-xs" [value]="event.status" [severity]="getStatusSeverity(event.status)"></p-tag>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap !text-center">{{ event.attemptsCount }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap !text-center">{{ event.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap !text-center hidden sm:table-cell">{{ event.lastAttemptAt ? (event.lastAttemptAt | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()">
                  <p-button icon="pi pi-eye" rounded [text]="true" severity="secondary" (onClick)="showDetails(event)" pTooltip="Ver Detalles" tooltipPosition="left" appendTo="body"></p-button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No hay eventos registrados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }

  </div>
</div>

<p-menu #rowMenu [model]="rowMenuItems" [popup]="true" appendTo="body" />

<p-drawer
  [visible]="webhookDetailsOpen()"
  position="right"
  (visibleChange)="onWebhookDrawerVisibleChange($event)"
  styleClass="webhook-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-send text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle del webhook</h3>
      </div>
      @if (selectedWebhookDetail() && !webhookDetailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="editWebhookFromDrawer()"
          appDisableUnless="WEBHOOK_WRITE">
          <i class="pi pi-pencil text-sm"></i>
          Editar
        </button>
      }
    </div>
  </ng-template>
  @if (webhookDetailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Cargando webhook...</p>
    </div>
  } @else if (selectedWebhookDetail()) {
    <app-webhook-read [webhook]="selectedWebhookDetail()!" />
  }
</p-drawer>

<p-drawer [visible]="sidebarVisible()" position="right" (visibleChange)="onDrawerVisibleChange($event)" styleClass="!w-[600px]" [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full border-b border-slate-200 pb-2">
      <div>
        <h3 class="text-lg font-semibold text-slate-900">Detalle del evento</h3>
        @if (selectedEvent()) {
          <div class="text-sm text-slate-500 mt-0.5 flex items-center gap-2">
            <span>Evento #{{ selectedEvent()?.id }}</span>
            <p-tag class="!text-xs" [value]="selectedEvent()?.status" [severity]="getStatusSeverity(selectedEvent()?.status)"></p-tag>
          </div>
        }
      </div>
      <div class="flex items-center gap-2 shrink-0">
        @if (selectedEvent()?.id != null) {
          <p-button
            label="Reenviar"
            icon="pi pi-replay"
            severity="secondary"
            [rounded]="true"
            [loading]="resendLoading()"
            (onClick)="resendEvent()"
            pTooltip="Reenvía el evento con el mismo payload original."
            appDisableUnless="WEBHOOK_WRITE"
            tooltipPosition="left"
            appendTo="body" />
        }
      </div>
    </div>
  </ng-template>

  <div *ngIf="selectedEvent()" class="flex flex-col gap-4 p-2">
    <div class="rounded-lg border border-slate-200 bg-white p-3">
      <h4 class="font-semibold mb-2 text-slate-900">Webhook destino</h4>
      @if (selectedEvent()?.webhookId != null) {
        <div class="flex flex-col gap-1">
          <a
            href="#"
            (click)="openWebhookDetails(null, selectedEvent()?.webhookId); $event.preventDefault()"
            class="text-sm font-medium text-sky-700 hover:text-sky-800 no-underline">
            #{{ selectedEvent()?.webhookId }}
            @if (selectedEvent()?.webhookDescription) {
              · {{ selectedEvent()?.webhookDescription }}
            }
          </a>
          <code class="text-xs text-slate-600 break-all">{{ selectedEvent()?.webhookEndpoint }}</code>
        </div>
      } @else {
        <p class="m-0 text-sm text-slate-500">Este evento no tiene un webhook asociado (sin destinos al momento de crearse).</p>
      }
    </div>

    <div class="bg-slate-50 p-3 rounded border">
      <h4 class="font-semibold mb-2">Payload</h4>
      <pre class="bg-slate-900 text-slate-50 p-2 rounded text-xs overflow-auto max-h-60">{{ formatPayload(selectedEvent()?.payload) }}</pre>
    </div>

    <h4 class="font-bold text-lg mt-4 border-b pb-2">Historial de Intentos</h4>

    <div *ngIf="intentsLoading()" class="flex justify-center p-4">
      <i class="pi pi-spin pi-spinner text-2xl"></i>
    </div>

    <div *ngIf="!intentsLoading() && intents().length === 0" class="text-center text-slate-500 py-4">
      No hay intentos registrados.
    </div>

    <div *ngFor="let intent of intents()" class="border rounded p-3 flex flex-col gap-2 shadow-sm">
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-2">
          <p-tag [value]="intent.httpCode ? intent.httpCode.toString() : 'N/A'"
            [severity]="intent.success ? 'success' : 'danger'"></p-tag>
          <span class="text-sm text-slate-500">{{ intent.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <span class="text-xs font-mono bg-slate-100 px-2 py-1 rounded">{{ intent.executionTimeMs }}ms</span>
      </div>

      <div *ngIf="intent.errorMessage" class="text-red-600 text-sm bg-red-50 p-2 rounded border border-red-100">
        <strong>Error:</strong> {{ intent.errorMessage }}
      </div>

      <div *ngIf="intent.responseBody" class="text-xs">
        <details>
          <summary class="cursor-pointer text-blue-600 font-semibold mb-1">Ver Respuesta</summary>
          <pre class="bg-slate-100 p-2 rounded overflow-auto max-h-40">{{ intent.responseBody }}</pre>
        </details>
      </div>
    </div>
  </div>
</p-drawer>
